import * as React from 'react';

type TransactionListProps = {
  children: React.ReactNode;
};

export const TransactionList = ({children}: TransactionListProps) => (
  <div className="border-border flex max-h-80 flex-col gap-1.5 overflow-y-auto rounded-lg border p-2">
    {children}
  </div>
);

type TransactionRowProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const TransactionRow = ({
  children,
  className,
  ...props
}: TransactionRowProps) => (
  <label
    className={`border-border flex items-center gap-2 border-b pb-1.5 last:border-b-0 last:pb-0 ${className ?? ''}`}
    {...props}
  >
    {children}
  </label>
);

type ErrorTextProps = {
  children: React.ReactNode;
};

export const ErrorText = ({children}: ErrorTextProps) => (
  <div className="text-destructive text-sm">{children}</div>
);

type InfoTextProps = {
  children: React.ReactNode;
};

export const InfoText = ({children}: InfoTextProps) => (
  <p className="text-muted-foreground m-0">{children}</p>
);

type LoadMoreRowProps = {
  children: React.ReactNode;
};

export const LoadMoreRow = ({children}: LoadMoreRowProps) => (
  <div className="mt-2 flex justify-end gap-2">{children}</div>
);

type LoadMoreButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const LoadMoreButton = ({
  children,
  className,
  ...props
}: LoadMoreButtonProps) => (
  <button
    className={`border-border bg-background rounded-md border px-4 py-1.5 text-sm disabled:cursor-not-allowed disabled:opacity-50 ${className ?? ''}`}
    {...props}
  >
    {children}
  </button>
);
